class CollectionFiltersPrime extends HTMLElement {
  constructor() {
    super();
    this.init();
  }

  init() {
    const activeItem = this.querySelector('li[data-active="true"]');
    if (!activeItem) return;

    const closestUl = activeItem.closest('ul');
    if (closestUl) {
      activeItem.scrollIntoView({
        behavior: 'smooth',
        block: 'center',
        inline: 'center'
      });
    }
  }
}

customElements.define('collection-filters-prime', CollectionFiltersPrime);
